	
(function ( $ ) {
 	"use strict";
	
	$.pad = function(str, char, max) {
		str		= str.toString();
		char	= char.toString();
  		max		= parseInt(max);
		return str.length < max ? $.pad(char + str, char, max) : str;
	};
	
    $.fn.cstmCountSigns = function( options ) {
 		
		var config	= {
			isInitializedClassName: 'cstm-count-signs-initialized'
		};
		
        // have default options.
        var settings = $.extend({
            // These are the defaults.
            selector:			".cstm-count-signs",
            dataAttrName:		"data-cstm-count-signs-max",
			idSuffixCounter:	"_cstm-count-signs-counter",
			idSuffixCount:		"_cstm-count-signs-count",
			idSuffixMax:		"_cstm-count-signs-max",
			maxDigits:			3,
			padChar:			"0",
			autoFormat:			false,
			defaultEvents:		'input blur',
        }, options );
		
		this.each( function() {
			
			var elem = $( this );
			
			// bind events
			if( !elem.hasClass(config.isInitializedClassName+'-events') ) {
				elem.bind(settings.defaultEvents, function() {
					$(settings.selector).cstmCountSigns( settings );
				}).addClass(config.isInitializedClassName+'-events');
			}
			
			var fieldId 	= elem.attr('id');
			var fieldTxt	= elem.val();
			var fieldTxtOrg = fieldTxt;
			var maxSigns	= parseInt(elem.attr(settings.dataAttrName));

			fieldTxt = fieldTxt.replace(/\n/g, "");
			fieldTxt = fieldTxt.replace(/\r/g, "");

			var numSigns = fieldTxt.length ? fieldTxt.length : 0;

			$('#'+fieldId+settings.idSuffixCount).html( (settings.autoFormat ? $.pad(numSigns, settings.padChar, settings.maxDigits) : numSigns) );
			$('#'+fieldId+settings.idSuffixMax).html(maxSigns);

			$('#'+fieldId+settings.idSuffixCounter).removeClass('text-danger text-success text-info');
			if(maxSigns && numSigns && numSigns < maxSigns) {
				$('#'+fieldId+settings.idSuffixCounter).removeClass('text-danger text-info').addClass('text-success');
			}
			if(maxSigns && numSigns === maxSigns) {
				$('#'+fieldId+settings.idSuffixCounter).removeClass('text-success text-info').addClass('text-info'); 
			}
			if(maxSigns && numSigns > maxSigns) {
				$('#'+fieldId+settings.idSuffixCounter).removeClass('text-success text-info').addClass('text-danger');
				elem.val(fieldTxtOrg.substring(0, maxSigns) );
			}
        });
				  
 		return this;
    };
 
}(jQuery));
